export default "__VITE_ASSET__DigoFuyi__"